import React from "react";
import { TrashIcon, ArrowPathIcon } from "@heroicons/react/24/outline";

import dummyImage from "../../../assets/dummyPreview.png";
import styles from "./smartImageCard.module.css";

export function SmartImageCard({
  card,
  onConfirmUpload,
  onReplace,
  onRemove,
}) {
  const hasError = Boolean(card.error);
  const isUploaded = Boolean(card.uploadedUrl);

  console.log("card", card)

  return (
    <div className={`${styles.card} ${hasError ? styles.errorCard : ""}`}>
      {/* PREVIEW */}
      <div className={styles.previewBox}>
        <img
          src={card.error?.type === "invalid" ? dummyImage : card.preview}
          className={styles.previewImg}
          alt=""
        />
      </div>

      {/* META */}
      <div className={styles.meta}>
        {card.width && card.height && (
          <span className={hasError ? styles.warn : ""}>
            {card.width} × {card.height}
          </span>
        )}

        {hasError && (
          <span className={styles.errorText}>
            {card.error.message}
          </span>
        )}

        {isUploaded && (
          <a href={card.uploadedUrl} target="_blank" rel="noreferrer">
            {card.uploadedUrl}
          </a>
        )}
      </div>

      {/* ACTIONS */}
      <div className={styles.actions}>
        {/* CONFIRM (only valid + not uploaded) */}
        {!hasError && !isUploaded && (
          <button
            className={styles.confirmBtn}
            onClick={() => onConfirmUpload(card)}
            disabled={card.uploading}
          >
            {card.uploading ? "Uploading…" : "Confirm"}
          </button>
        )}

        {/* CHANGE IMAGE (only error state) */}
        {hasError && (
          <button
            className={styles.changeBtn}
            onClick={() => onReplace(card.id)}
          >
            Change Image
          </button>
        )}

        {/* UPLOADED ACTIONS */}
        {isUploaded && (
          <>
            <TrashIcon
              className={styles.icon}
              onClick={() => onRemove(card.id)}
            />
            <ArrowPathIcon
              className={styles.icon}
              onClick={() => onReplace(card.id)}
            />
          </>
        )}
      </div>
    </div>
  );
}
